import React, { useEffect } from 'react';

import { IconType } from 'react-icons/lib';

import { Container } from './styles';

import Vimeo from '../../components/Vimeo';
import VideoGallery from '../../components/VideoGallery';
import ImageGallery from '../../components/ImageGallery';
import Speakers from '../Speakers';
import { Link } from 'react-router-dom';

interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

const Tenda: React.FC = () => {

  useEffect( () => {
    window.scrollTo(0,0);
  },[])

  const videos = [
    { video_id : '588944625', type_id : '2'},
    {video_id : '588944578', type_id : '2'},
    {video_id : '588944528', type_id : '2'}
  ];

  const gallery = [
    { url : 'mostra/1.png'},
    { url : 'mostra/2.png'},
    { url : 'mostra/3.png'},
    { url : 'mostra/4.png'},
    { url : 'mostra/5.png'},
    { url : 'mostra/6.png'},
    { url : 'mostra/7.png'},
    { url : 'mostra/8.png'},
    { url : 'mostra/9.png'},
    { url : 'mostra/10.png'},
    { url : 'mostra/11.png'},
    { url : 'mostra/12.png'},
    { url : 'mostra/13.png'},
    { url : 'mostra/14.png'},
  ]

  const kids = [
    { url : 'mostra/kids1.jpg'},
    { url : 'mostra/kids2.jpg'},
  ]

  return (
    <>


      <Container>
        <div>
      <img className="fundoTenda" style={{width: '100%'}}  src="/apoio/tenda/FundoTenda.png"/>
      <Link className="tenda"  to="/tenda-paulo-freire/vozes-de-paulo-freire">
         <img  src="/apoio/tenda/tenda.png"/>
         </Link>
    <Link className="cozinheiro" to="/tenda-paulo-freire/encontro_como_alimento"><img  src="/apoio/tenda/encontro_como_alimento.png"/>
    <img className="tenda_title" src="/apoio/tenda/encontro_como_alimento_title.png"/>
    </Link>
    <Link className="meditacao" to="/tenda-paulo-freire/praticas_integrativas"><img  src="/apoio/tenda/praticas_integrativas.png"/>
    <img className="tenda_title" src="/apoio/tenda/praticas_integrativas_title.png"/>
    </Link>
    <Link className="fotografia" to="/tenda-paulo-freire/fotografia"><img  src="/apoio/tenda/fotografia.png"/>
    <img className="tenda_title" src="/apoio/tenda/fotografia_title.png"/>
    </Link>
    <Link className="livros" to="/tenda-paulo-freire/biblioteca"><img  src="/apoio/tenda/biblioteca.png"/>
    <img className="tenda_title" src="/apoio/tenda/biblioteca_title.png"/>
    </Link>
    <Link className="rodadagua" to="/tenda-paulo-freire/gotas-de-cultura"> <img  src="/apoio/tenda/gotas.png"/>
    <img className="tenda_title" src="/apoio/tenda/gotas_title.png"/>
    </Link>
    </div>
      </Container>
    </>
  );
};
export default Tenda;
